module.exports = __webpack_public_path__ + "img/oscar.91bb6807.png";